// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.claim-zNLCnb-content{width:100%;min-height:100%;overflow-y:auto;position:absolute}`, "",{"version":3,"sources":["webpack://./src/features/age-gate/view.module.scss"],"names":[],"mappings":"AAAA,sBACE,UAAA,CACA,eAAA,CACA,eAAA,CACA,iBAAA","sourcesContent":[".content {\n  width: 100%;\n  min-height: 100%;\n  overflow-y: auto;\n  position: absolute;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `claim-zNLCnb-content`
};
export default ___CSS_LOADER_EXPORT___;
